<template lang="pug">
div
  app-modal-cancelar-retificacao(
    v-if="showModalRetificacao",
    :idProcesso='idProcesso',
    :numeroProcesso='numeroProcesso',
    :setor='setor'
    @closeModal="closeRetificacao"
  )
  app-modal-visualizar-completo(
    v-if="showModalVisualizarProcesso && idProcesso !== null",
    @closeModal="showModalVisualizarProcesso = false",
    :idProcesso="idProcesso",
    :protocolo="protocolo",
    :numeroProcesso="numeroProcesso",
    :tipo="tipoProcesso"
  )
  el-card.card-container(shadow="hover")
    filtro(
      @pesquisar="pesquisar",
      @limpar="clear",
      :configuracaoFiltro="configuracaoFiltro",
      :filtroRapido="filtroRapido"
      :showFiltroTipoMultiplo="showFiltroTipoMultiplo"
    )
  app-listagem(
    v-if="exibirListagem"
    :has-refresh-button="true",
    :showButtonOrdemServico="false",
    :showButtonAssinatura="false",
    :has-expansivel="false",
    :json-headers="colunas",
    :json-data="items",
    :totalElements="totalElements",
    :pagina="filtro.pagina",
    :hasFiltroRapido="true",
    :filtro="filtro",
    :infoPrazos="showInfoVencimento() && infoPrazos"
    @atualizarFiltro="atualizarFiltro",
    @updateListagem="refresh",
    @changePage="changePage",
    @sort="sort",
    @exportarCsvFiltroAnalise="exportarCsvFiltroAnalise",
    @executar="executar",
    @selected="false"
    :showButtonRegerar="showButtonRegerar()"
  )
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AppListagem from '@/components/AppListagem'
import Filtro from './Filtro'
import FILTRO_EMPTY from '@/models/filtro'
import AppModalVisualizarCompleto from '@/screens/analise/components/modal/AppModalVisualizarCompleto'
import AppModalCancelarRetificacao from '@/screens/analise/components/modal/AppModalCancelarRetificacao'
const { filtro, isGcgCgir, showFiltroTipoMultiplo } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default
const BaseFiltro = require('./' + process.env.ESTADO + '/BaseFiltro').default

export default {

  beforeRouteLeave (to, from, next) {
    next()
  },

  components: {
    AppListagem,
    Filtro,
    AppModalVisualizarCompleto,
    AppModalCancelarRetificacao
  },

  mixins: [
    BaseFiltro
  ],

  data () {
    return {
      filtro: FILTRO_EMPTY('AGUARDANDO_VALIDACAO_ANALISE_UC'),
      items: [],
      exibirListagem: true,
      totalElements: 0,
      infoPrazos: undefined,
      setoresInfoVencimento: [ 'GAC', 'CAF', 'GPA', 'GCQ', 'GEO', 'GCG', 'CGIR', 'DEAF', 'GRF', 'GAM', 'CDI', 'GIT' ],
      protocolo: null,
      showModalVisualizarProcesso: false,
      showModalRetificacao: false,
      idProcesso: null,
      numeroProcesso: null,
      setor: null,
      configuracaoFiltro: {
        filtroSituacao: filtro?.filtroResponsavel?.AGUARDANDO_VALIDACAO_ANALISE || [],
        filtroResponsavel: filtro?.filtroResponsavel?.AGUARDANDO_VALIDACAO_ANALISE || [],
        filtroMunicipio: filtro?.filtroMunicipio?.AGUARDANDO_VALIDACAO_ANALISE || [],
        filtroVistoriador: filtro?.filtroVistoriador?.CAIXA_ENTRADA || []
      },
      colunas: [
        { id: 0, titulo: 'Processo', propriedade: 'numeroProcesso', marcado: () => this.showButtonRegerar(), ordem: 1, acoes: [], type: 'icone', icone: 'comment-alt' },
        { id: 1, titulo: 'Número do CNUC', propriedade: 'cpfCnpjInteressado', ordem: 2, acoes: [] },
        { id: 2, titulo: 'Nome da UC', propriedade: 'nomeRazaoSocialInteressado', ordem: 3, acoes: [] },
        { id: 3, titulo: 'Situação', propriedade: 'status', ordem: 4, acoes: [], exibir: () => true },
        { id: 3, titulo: 'Esfera', propriedade: 'esfera', ordem: 4, acoes: [], exibir: () => true },
        { id: 3, titulo: 'Grupo de manejo', propriedade: 'grupoDeManejo', ordem: 4, acoes: [], exibir: () => true },
        { id: 5, titulo: 'Data Chegada', propriedade: 'dataChegadaSetor', ordem: 4, acoes: [] },
        { id: 6, titulo: 'Tipo de Processo', propriedade: 'tipo', ordem: 5, acoes: [] },
        { id: 7, titulo: 'Responsável', propriedade: 'responsavel', ordem: 5, acoes: [], exibir: () => true },
        {
          id: 9, titulo: 'Ações', propriedade: 'tipo', ordem: 6, //eslint-disable-line
          acoes: [
            { id: 1, nome: 'Validar Processo', icone: 'fa-check', codigo: 'VALIDAR', ordem: 1, show: this.showValidarProcesso, showToltip: this.showToltip, textToltip: this.textToltip },
            { id: 2, nome: 'Visualizar Processo', icone: 'fa-eye', codigo: 'VISUALIZAR_PROCESSO', ordem: 2, show: this.showVisualizarProcesso }
          ]
        }
      ],
      usuario: null,
      showFiltroTipoMultiplo,
      filtroRapido: null
    }
  },

  props: {
    tipo: {
      type: String,
      required: false // trocar para true, quando tiver a props
    }
  },

  async created () {
    this.usuario = await this.usuarioLogado
  },

  computed: {
    ...mapGetters({
      usuarioLogado: 'auth/usuarioLogado'
    })
  },

  methods: {
    ...mapActions({
      exportarCsvAnalise: 'processo/exportarCsvAnalise'
    }),
    showColuna (coluna) {
      return this.configuracaoFiltro[coluna].find(perfil => perfil === this.usuario?.perfilSelecionado?.codigo) !== undefined
    },
    showInfoVencimento () {
      return this.setoresInfoVencimento.find(setor => setor === this.usuario?.perfilSelecionado?.setor?.codigo)
    },
    VALIDAR_OFICIO: (_this, { item }) => {
      _this.$router.push({
        name: 'oficio',
        query: {
          idProcesso: item.id
        },
        params: {
          isEdicao: true
        }
      })
    },
    VALIDAR: (_this, { item }) => {
      _this.$router.push({
        name: 'analise/validar',
        params: {
          idProcesso: item.id,
          acaoCaixa: 'VALIDACAO'
        }
      })
    },
    async CONFERIR_TITULO (_this, { item }) {
      this.$router.push({
        name: 'conferencia-titulo-certidao',
        params: {
          idProcesso: item.id,
          tipo: 'EMITIR_TITULO',
          numeroProcesso: item.numeroProcesso
        }
      })
    },
    async CONFERIR_CERTIDAO (_this, { item }) {
      this.$router.push({
        name: 'conferencia-certidao',
        params: {
          idProcesso: item.id,
          tipo: 'EMITIR_TITULO',
          numeroProcesso: item.numeroProcesso
        }
      })
    },

    VISUALIZAR_PROCESSO (_this, { item }) {
      this.idProcesso = item.id
      this.numeroProcesso = item.numeroProcesso
      this.tipoProcesso = item.tipoCodigo
      this.protocolo = item.numeroProtocolo
      this.showModalVisualizarProcesso = true
    },
    CANCELAR_RETIFICACAO (_this, {item}) {
      this.idProcesso = item.id
      this.numeroProcesso = item.numeroProcesso
      this.protocolo = item.numeroProtocolo
      this.setor = item.setor
      this.showModalRetificacao = true
    },
    atualizarFiltro (novoFiltro) {
      this.filtro = {
        ...this.filtro,
        ...novoFiltro
      }
      this.filtroRapido = novoFiltro
    },
    async exportarCsvFiltroAnalise () {
      await this.filtroComColunasExibidas()
      this.exportarCsvAnalise(this.filtro)
    },
    closeRetificacao () {
      this.showModalRetificacao = false
      this.refresh()
      this.exibirListagem = false
      setTimeout(() => {
        this.exibirListagem = true
      }, 1000)
    },
    async CONFERIR_VTN (_this, { item }) {
      this.$router.push({
        name: 'CONFERIR_VTN',
        params: {
          processo: item
        }
      })
    },

    showButtonRegerar () {
      return isGcgCgir && isGcgCgir(this.usuario?.perfilSelecionado?.setor?.codigo)
    }
  }
}
</script>
<style lang="scss" scoped>
.card-container {
  margin: 20px;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/listagem/AguardandoValidacaoListagemUc.vue